import './style.scss'
const prefixCls = 'sl-row';

export const Row = {
  name:'Row',
  props:{
    gutter:{
      type:Number,
      default:0
    },
    align:{
      type:String,
      default:'top'
    },
    justify:{
      type:String,
      default:'start'
    },
    type:{
      type:String,
      default:'flex'
    }
  },
  provide() {
    return {
      gutter: this.gutter
    }
  },
  render(){
    const { type , gutter, justify , align , $scopedSlots } = this
    const style = {}
    if(gutter){
      style.marginLeft = -this.gutter / 2 + 'px'
      style.marginRight = -this.gutter / 2 + 'px'
    }
    return (
      <div class={[`${prefixCls}-${type}`,`${prefixCls}-${type}-${align}`,`${prefixCls}-${type}-${justify}`]} style={style}>
        { $scopedSlots.default ? $scopedSlots.default() : null }
      </div>
    )
  }
}

export const Col = {
  name:"Col",
  props:['span','xs','sm','md','lg','xl','xxl'],
  inject: {
    gutter: {
      default: 0
    }
  },
  render(){
    const { gutter , $scopedSlots , span , xs , sm , md , lg , xl, xxl } = this
    const classes = []
    if(span) classes.push(`sl-col-${span}`)
    if(xs) classes.push(`sl-col-xs-${xs}`)
    if(sm) classes.push(`sl-col-sm-${sm}`)
    if(md) classes.push(`sl-col-md-${md}`)
    if(lg) classes.push(`sl-col-lg-${lg}`)
    if(xl) classes.push(`sl-col-xl-${xl}`)
    if(xxl) classes.push(`sl-col-xxl-${xxl}`)

    const style = {}
    if(gutter){
      style.paddingLeft = gutter / 2 + 'px'
      style.paddingRight = gutter / 2 + 'px'
    }

    return (
      <div class={classes} style={style}>
        { $scopedSlots.default ? $scopedSlots.default() : null }
      </div>
    )
  }
}